import { render } from "./Permission.vue?vue&type=template&id=d0bff10a&scoped=true"
import script from "./Permission.vue?vue&type=script&lang=js"
export * from "./Permission.vue?vue&type=script&lang=js"

import "./Permission.vue?vue&type=style&index=0&id=d0bff10a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d0bff10a"

export default script